export default __webpack_public_path__ + "static/media/11_Business-ProductArchitecture-InteriorEschweilerPhotography_M1A7563_3_.3e4f7c36.jpg";